import { render } from "./CometChatUserListItem.vue?vue&type=template&id=05b95170&scoped=true"
import script from "./CometChatUserListItem.vue?vue&type=script&lang=js"
export * from "./CometChatUserListItem.vue?vue&type=script&lang=js"

import "./CometChatUserListItem.vue?vue&type=style&index=0&id=05b95170&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05b95170"]])

export default __exports__